import React, { Component } from "react";
import { CLIENT_INFO_UPDATE, GetSettingURL } from "./../helper/Constants";
import Apihelpers from "./../helper/ApiHelper";
import { Alert } from 'rsuite';
//import { reactLocalStorage } from 'reactjs-localstorage';
//import { Textbox, Textarea } from 'react-inputs-validation';
import $ from "jquery";
//import Select2 from 'react-select2-wrapper';

export default class ClientProfileUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: this.props.userData || {},

      //hasupdateNumberError: false,
      //hasUpdateAddressError: false,

      updateMobileNumber: this.props.userData.contact_number,
      updateAddress: this.props.userData.address,
      updateEmail: this.props.userData.email,
      updateUserId: this.props.userData._id,
      bbUserBusinessUnit:this.props.userData.business_unit,
      buUnites:[]
    }
  }

  componentDidMount() {
    this.get_Data_Of_Setting();
  }

  updateClientProfileInfo = (e) => {
    e.preventDefault();
    //this.toggleUpdateValidating(true);
    if (Number.isInteger(parseFloat(this.state.updateMobileNumber))) {
      let updatepostdata = { userid: this.state.updateUserId};
      updatepostdata['contact'] = this.state.updateMobileNumber;
      updatepostdata['address'] = this.state.updateAddress;
      updatepostdata['email'] = this.state.updateEmail;
      updatepostdata['business_unit'] = this.state.bbUserBusinessUnit;
      updatepostdata['sendInfo'] = false;
      
      if(updatepostdata.contact !== this.state.userData.contact_number || updatepostdata.email !== this.state.userData.email || updatepostdata.business_unit !== this.state.userData.business_unit) {
        updatepostdata.sendInfo = true;
      }

      console.log('updatepostdata',updatepostdata);
      $('.loader').css('display', 'block');
      //return;
      Apihelpers.postdataresponse(CLIENT_INFO_UPDATE, updatepostdata).then(res => {
        if (res.data.status === true) {
          Alert.success("Client Info Successfully Updated");
          setTimeout(function(){
            window.location.reload();
          },1000);
        } else {
          Alert.error("Error While Update Client Info");
        }
      });
    } else {
      Alert.error("Please add valid phone number");
    }
  }
  get_Data_Of_Setting = () => {
    Apihelpers.getdataresponse(GetSettingURL).then(res => {
      var data = res.data.data;
      console.log('data',data);
      this.setState({
        buUnites:data.bbuser_business_unit_options || []
      });
    });
  }

  render() {
    return (
      <div className="customPopup" style={{'display':'block'}}>
        <div className="bgLayer" />
        <div className="popUpBox" style={{ maxWidth: "770px" }}>
          <span className="closeIcon" onClick={this.props.hideUpdateModel} > </span>
          <div className="popScroll" style={{ padding: "20px 20px 30px 20px" }}>
            {
              //JSON.stringify(this.state.userData, null,2)
            }
            <div className="popUpHed">
              <h3>{this.state.userData.name}</h3>
              <div className="desc">Client Profile Update</div>
            </div>
            <form className="form" method="post" onSubmit={this.updateClientProfileInfo}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-title">Phone Number <span className="ex">*</span></label>
                    <input className="form-control" type="text" required="required" name="updateMobileNumber" onChange={(e)=>{
                      this.setState({updateMobileNumber: e.target.value})
                    }} minLength={10} maxLength={10} value={this.state.updateMobileNumber} placeholder="Enter Nuber" />
                  </div>
                  <div className="form-group">
                    <label className="control-title">Email <span className="ex">*</span></label>
                    <input className="form-control" type="email" required="required" name="updateEmail" onChange={(e)=>{
                      this.setState({updateEmail: e.target.value})
                    }} value={this.state.updateEmail} placeholder="Enter Email" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                      <label className="control-title">Business Unit <span className="ex">*</span></label>
                      <select className="form-control" required="required" onChange={(e)=>{
                        this.setState({
                          bbUserBusinessUnit: e.target.value
                        })
                      }} value={this.state.bbUserBusinessUnit}>
                        <option value="">--select--</option>
                        {
                          this.state.buUnites.map((it)=>{
                            return(
                              <option key={it} value={it}>{it}</option>
                            )
                          })
                        }
                      </select>
                    </div>
                  <div className="form-group">
                    <label className="control-title">Address <span className="ex">*</span></label>
                    <textarea className="form-control" required="required" name="updateAddress" onChange={(e)=>{
                      this.setState({updateAddress:e.target.value})
                    }} placeholder="Enter Address" defaultValue={this.state.updateAddress}></textarea>
                  </div>
                </div>
              </div>
              <div className="submitRow">
                <button className="backBtn" onClick={this.props.hideUpdateModel} type="button">Cancel</button>
                <button className="blueBtn" type="submit">Update</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

